export enum CircleProgressBarType {
    small = 'small',
    big = 'big',
    xs = 'xs'
}
